export default {
  initialize: () => {
    var $customIframe = $('body [data-editable="customIframe"]');
    var src = $customIframe.attr('data-src');

    $customIframe.html('<iframe src="' + src + '"></iframe>');
  },
};
